import { Dictionary } from './dictionary';

export const enDictionary: Dictionary = {
  en: {
    title: 'MEKH Dissemination Database',
    reports: 'Reports',
    no_report_found: 'No report was found!',
    navigate_to_reports: 'Back to reports',
    contact: 'Contact:',
    mekh_logo_aria_label: 'MEKH logo. Click here to navigate to the MEKH website.',
    mekh_ugyfelszolgalat_aria_label: 'Click here to contact customer service.',
    only_public: 'Show only public data',
    all_public: 'Show all data',
    unit_of_measeure: 'Unit of measure',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    halfYear: 'Semester',
    HY1: '1st Semester',
    HY2: '2nd Semester',
    quarter: 'Quarter',
    tetelek: 'Item',
    orszag: 'Country',
    termekek: 'Product',
    tevekenyseg: 'Economic Activity',
    keszletek: 'Type of stock',
    engedelyes: 'Licensee',
    adat_tipus: 'Datatype',
    regiok_es_varmegyek: 'Regions and counties',
    felhasznalasi_cel: 'End use',
    ertek: 'Value',
    ezer_kobmeter: 'thousand m3',
    ezer_tonna: 'thousand tonnes',
    kilo_tonna: 'kt',
    gigawatt_ora: 'GWh',
    ezer_forint: 'thousand HUF',
    forint: 'HUF',
    szazalek: 'Percentage',
    terajoule_netto: 'TJ (NCV)',
    terajoule_brutto: 'TJ (GCV)',
    huf_gigajoule_netto: 'HUF/GJ (NCV)',
    huf_gigajoule_brutto: 'HUF/GJ (GCV)',
    huf_kilowatt_ora: 'HUF/kWh',
    fogyasztasi_sav: 'Consumption band',
    adozasi_szint: 'Tax level',
    help: 'Help',
    report_categories: 'Report categories',
    report_list: 'Reports',
    treeitem_H1: 'Natural gas reports',
    treeitem_H101: 'Natural gas transmission',
    treeitem_H102: 'Natural gas storage',
    treeitem_H103: 'Natural gas trading',
    treeitem_H2: 'Electricity reports',
    treeitem_H201: 'Data of the hungarian electricity system',
    treeitem_H202: 'Power plant with a capacity of 50MW or above',
    treeitem_H203: 'Electricity trading',
    treeitem_H204: 'Electric car charging',
    treeitem_S1: 'Infra-annual data',
    treeitem_S101: 'Coal and Coal Products',
    treeitem_S102: 'Oil and Petroleum Products',
    treeitem_S103: 'Natural Gas',
    treeitem_S104: 'Electricity',
    treeitem_S105: 'Primary Energy Balance',
    treeitem_S106: 'Energy prices',
    treeitem_S107: 'S107',
    treeitem_S108: 'S108',
    treeitem_S109: 'S109',
    treeitem_S2: 'Annual data',
    treeitem_S201: 'Coal and Coal Products',
    treeitem_S202: 'Oil and Petroleum Products',
    treeitem_S203: 'Natural Gas',
    treeitem_S204: 'Electricity',
    treeitem_S205: 'Heat',
    treeitem_S206: 'Renewable energy sources',
    treeitem_S207: 'Energy Balance',
    treeitem_S208: 'Final energy consumption',
    treeitem_S209: 'S209',
    chartType_bar: 'Bar',
    chartType_line: 'Line',
    chartType_area: 'Area',
    chartType_fullstackedarea: 'Fullstackedarea',
    chartType_fullstackedbar: 'Fullstackedbar',
    chartType_fullstackedline: 'Fullstackedline',
    chartType_fullstackedspline: 'Fullstackedspline',
    chartType_fullstackedsplinearea: 'Fullstackedsplinearea',
    chartType_scatter: 'Scatter',
    chartType_spline: 'Spline',
    chartType_splinearea: 'Splinearea',
    chartType_stackedarea: 'Stackedarea',
    chartType_stackedbar: 'Stackedbar',
    chartType_stackedline: 'Stackedline',
    chartType_stackedspline: 'Stackedspline',
    chartType_stackedsplinearea: 'Stackedsplinearea',
    chartType_steparea: 'Steparea',
    chartType_stepline: 'Stepline',
    metaws_title: 'Summary',
    metaws_dowload_date: 'Date of download:',
    metaws_publisher: 'Published by:',
    metaws_mekh: 'Hungarian Energy and Public Utility Regulatory Authority',
    metaws_source: 'Data source:',
    metaws_uom: 'Unit of measure:',
    metaws_lastupdate: 'Date of last update:',
    metaws_filters: 'Applied Filters',
    metaws_seleted_all: 'Selected All',
    metaws_year: 'Year'
  },
};
